// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__3SQbA","Label":"Input_Label__XDr9D","InputElement":"Input_InputElement__1GPNB","Invalid":"Input_Invalid__Qhh0j"};